import React, {useState, useContext, useEffect} from 'react';
import {useRouter} from 'next/router';
import {UserContext} from 'components/UserProvider';

import Header from 'components/Header';
import Footer from 'components/Footer';
import Info from './components/Info';
import WorksList from './components/WorksList/index.page';
import Tab, {TABS_KEY} from './components/Tab';

import {personalBannerBg} from 'assets';
import { enhancedEventKeRlog } from '../../util'

import s from './index.module.scss';

interface RouterQuery {
  [key: string]: string | string[] | undefined
}

const getUserId = (query: RouterQuery) => {
  let id, _userId = query.userId;
  if(!_userId) return '';
  if(Array.isArray(_userId)) {
    _userId = _userId[0];
  }
  try {
    id = atob(_userId);
  } catch(e) {
    id = String(_userId);
  }
  return id
}

const PersonalCenter: React.FC = () => {

  const router = useRouter();
  const {user, dispatch} = useContext(UserContext);
  const userId = getUserId(router.query);
  const isSelf = !userId || user?.userId === userId;
  const [currTab, setCurrTab] = useState(TABS_KEY.MY_WORKS);
  const currUserId = userId || user?.userId;

  useEffect(() => {
    setCurrTab(TABS_KEY.MY_WORKS)
  }, [currUserId])

  // 埋点
  useEffect(() => {
    enhancedEventKeRlog('page_enter', {
      page_name: '个人中心',
    })
  }, [])

  return (
    <>
      <Header />
      <div className={s.banner}  style={{backgroundImage: `url(${personalBannerBg})`}} ></div>
      <div className={s.content}>
          <Info
            userId={userId}
            isSelf={isSelf}
            isLogin={!!user}
            onReportSuccess={() => {
              dispatch({type: 'updateUnread'})
            }}
          />
          <Tab
            isSelf={isSelf}
            current={currTab}
            onChange={setCurrTab}
          />
          <WorksList
            isSelf={isSelf}
            userId={currUserId}
            type={currTab}
            query={{}}
          />
      </div>
      <Footer />
    </>
  )
}


export default PersonalCenter;
